import React, { Fragment } from 'react';
import { resolve } from 'library/helpers/path-resolver';
import { Switch, Route, Link, Redirect, withRouter } from 'library/util/core-router';
import { ShimmyValue } from 'library/components/shimmy';
import HiringQuery from 'apps/hiring/util/query';
import withData from 'util/hoc/with-data';
import Swimlanes, { Swimlane } from 'library/components/swimlanes';
import FlagSvg from 'library/icons/flag.svg';
import AlertSvg from 'library/icons/alert.svg';
import LoaderSvg from 'library/icons/loader.svg';
import Modal from 'library/components/modal';
import InviteModal from 'apps/hiring/components/invite-modal';

const pendingSurveyStatusMap = {
  real: "Part 1",
  ideal: "Part 2",
  invited: "Invited"
}

const SurveyStatusType = ({ assessment }) => (
  <div className="hiring-survey-status-dot" data-tooltip={pendingSurveyStatusMap[resolve(assessment, 'progress', 'invited')]} data-tooltip-position="top">
    <span className={`hiring-survey-status-dot-${resolve(assessment, 'progress', 'invited')}`} />
  </div>
);
const EvaluationFlag = ({ flag }) => {
  switch (flag) {
  case 'invalid':
    return <FlagSvg className="hiring-survey-status-flag-invalid" style={{width: '1em', height: '1em'}} />;
  case 'warning':
    return <AlertSvg className="hiring-survey-status-flag-warning" style={{width: '1em', height: '1em'}} />;
  default:
    return null;
  }
};

const ConfirmModal = ({ callback=()=>{} }) => (
  <div className="hiring-modal">
    <h1>Are you sure?</h1>
    <div>
      <button onClick={()=>callback(false)}>No</button>
      <button onClick={()=>callback(true)}>Yes</button>
    </div>
  </div>
)

const EvaluationStatusType = ({ assessment }) => (
  <div className="hiring-survey-status-flags">
    {
      parseInt(assessment.validity_score) < 100
        ? (
          <span
            data-tooltip={`${assessment.validity_score}% valid`}
            data-tooltip-position="top"
          >
            <AlertSvg
              className="hiring-survey-status-flag-warning"
              style={{width: '1em', height: '1em'}}
            />
          </span>
        )
        : null
    }
    {
      assessment.validity_errors.split(',').map(f=><EvaluationFlag key={f} flag={f} />)
    }
  </div>
);

const LoadingStatus = () => (
  <div className="hiring-survey-status-loading">
    <div className="hiring-survey-status-loading-inner">
      <LoaderSvg />
    </div>
  </div>
);

const APPLICANT_STATUS_TYPES = {
  survey: SurveyStatusType,
  evaluate: EvaluationStatusType,
  loading: LoadingStatus,
};

const ApplicantCard = ({ id, user, dragStatus, type, ...props }) => {
  const Type = APPLICANT_STATUS_TYPES[dragStatus || type] || (()=>null);
  return (
    <div className="hiring-applicant-card" {...props}>
      <p>
        { [resolve(user, 'first_name', ''),resolve(user, 'last_name', '')].filter(c=>c).join(' ') }
        <small>
          { resolve(user, 'email', '') }
        </small>
      </p>
      {
        <Type {...props} />
      }
    </div>
  );
}

const DashboardLoading = () => (
  <div className="swimlanes">
    <div className="swimlane">
      <h2>Pending Surveys</h2>
      <div className="hiring-applicant-card-loading" />
      <div className="hiring-applicant-card-loading" />
    </div>
    <div className="swimlane">
      <h2>Evaluate</h2>
      <div className="hiring-applicant-card-loading" />
    </div>
    <div className="swimlane">
      <h2>Hired</h2>
      <div className="hiring-applicant-card-loading" />
      <div className="hiring-applicant-card-loading" />
    </div>
    <div className="swimlane">
      <h2>Rejected</h2>
      <div className="hiring-applicant-card-loading" />
      <div className="hiring-applicant-card-loading" />
      <div className="hiring-applicant-card-loading" />
    </div>
  </div>
);

const Wait = (timeout) => new Promise((resolve) => {
  setTimeout(resolve, timeout);
})
class HiringDashboard extends React.Component {

  state = {
    confirm: false
  }

  confirmModal = async (id, from, to) => {
    const response = await (new Promise((resolve) => {
      this.setState({
        confirm: {
          id: id,
          from: from,
          to: to,
          callback: resolve
        }
      });
    }));

    this.setState({
      confirm: false
    });

    return response;
  }

  loadModal = async (id, from, to) => {
    const values = [...resolve(this.props, 'graph_data/values', [])];
    for (let x = 0; x < values.length; x++) {
      for (let y = 0; y < values[x].values.length; y++) {
        if (values[x].values[y].id == id) {
          delete values[x].values[y].dragStatus;
          if (!(await this.confirmModal(id, from, to))) {
            const [fSwimlane,fIndex] = from.split('.').slice(1);
            const [tSwimlane,tIndex] = to.split('.').slice(1);
            //Get original element
            const [elem] = values[tSwimlane].values.splice(tIndex,1);
            //Insert into new spot
            values[fSwimlane].values.splice(fIndex,0,elem);
          }
          this.props.graph_update({
            values: values
          }, false, ()=>{}, false);
        }
      }
    }
  }

  handleReorderComplete = () => {
    for (const id in this.dragData) {
      if (
        !this.dragData[id].processing
      ) {
        this.dragData[id].processing = true;
        const {
          from,
          to,
          originalSection,
          newSection
        } = this.dragData[id];

        const values = [...resolve(this.props, 'graph_data/values', [])];

        if (originalSection !== newSection) {
          for (let x = 0; x < values.length; x++) {
            for (let y = 0; y < values[x].values.length; y++) {
              if (values[x].values[y].id == id) {
                values[x].values[y].dragStatus = 'loading';
                this.props.graph_update({
                  values: values
                }, false, ()=>{}, false);

                this.loadModal(id, from, to);
              }
            }
          }
        }

        // let newStatus = status;
        //
        // for (let x = 0; x < values.length; x++) {
        //   for (let y = 0; y < values[x].values.length; y++) {
        //     if (values[x].values[y].id == id) {
        //       if (originalSection !== newSection) {
        //         const [s,ns] = status.split('/');
        //         newStatus = `${newSection}/${ns}`;
        //         values[x].values[y].status = 'loading';
        //         values[x].values[y].disabled = true;
        //         this.loadCard(id, newStatus);
        //       } else {
        //         values[x].values[y].status = status;
        //       }
        //       this.props.graph_update({
        //         values: values
        //       });
        //
        //       delete this.dragData[id];
        //       return;
        //     }
        //   }
        // }

        delete this.dragData[id];
      }
    }
  }

  dragData = {};

  handleReorder = (from, to) => {
    const [fSwimlane,fIndex] = from.split('.').slice(1);
    const [tSwimlane,tIndex] = to.split('.').slice(1);

    if (fSwimlane === tSwimlane && fIndex === tIndex) {
      return;
    }

    const values = [...resolve(this.props, 'graph_data/values', [])];

    //Get original element
    const [elem] = values[fSwimlane].values.splice(fIndex,1);
    //Insert into new spot
    values[tSwimlane].values.splice(tIndex,0,elem);


    const id = values[tSwimlane].values[tIndex].id;
    this.dragData[id] = this.dragData[id] || {
      from: from,
      originalSection: values[fSwimlane].section,
      id: values[tSwimlane].values[tIndex].id
    };

    this.dragData[id].to = to;
    this.dragData[id].newSection = values[tSwimlane].section;
    values[tSwimlane].values[tIndex].dragStatus = 'dragging';

    this.props.graph_update({
      values: values
    }, false, ()=>{}, false);
  }

  state = {
  }

  mapSwimlanes = ({ label, section, values }, index) => {
    return (
      <Swimlane key={index} label={label}>
        {
          values.filter(c=>c).map((v) => (
            this.mapValues(v, section)
          ))
        }
      </Swimlane>
    )
  }

  handleClick = (e) => {
    const id = e.currentTarget.dataset.id;
    if (!id) return;
    resolve(this, 'props/history/push', ()=>{})(`/hiring/openings/${resolve(this, 'props/match/params/id', '')}/applicants/${id}`);
  }

  mapValues = ({ id, ...values }, section) => {
    return (
      <ApplicantCard
        type={section}
        key={id}
        id={id}
        data-id={id}
        onClick={this.handleClick}
        {...values}
      />
    );
  }

  render() {
    const {
      graph_data,
      graph_loading
    } = this.props;

    if (graph_loading) {
      return (
        <Fragment>
          <DashboardLoading />
        </Fragment>
      );
    }

    return (
      <Fragment>
        <Swimlanes disabled={true} onReorder={this.handleReorder} onReorderComplete={this.handleReorderComplete}>
          {
            graph_data.values.map(this.mapSwimlanes)
          }
        </Swimlanes>

        <Modal active={resolve(this.state, 'confirm', false)} onClose={()=>resolve(this.state, 'confirm/callback', ()=>{})(false)}>
          <ConfirmModal {...resolve(this.state, 'confirm', {})} />
        </Modal>

        {
          graph_data.totalApplicants == 0
            ? (
              <div className="hiring-dashboard-cta">
                <h1>There are currently no applicants</h1>
                <InviteModal type="opening" opening={graph_data.opening} />
              </div>
            )
            : null
        }
      </Fragment>
    );
  }
}

HiringDashboard.parseQueryData = (data) => {
  const out = {
    pending: [],
    evaluate: [],
    interview: [],
    hire: [],
    reject: []
  };

  for (const application of resolve(data, 'opening/applications/results', [])) {
    if (application.status === 'Hired') {
      out.hire.push(application);
    } else if (application.status === 'Rejected') {
      out.reject.push(application);
    } else if (!application.assessment || application.assessment.progress !== 'complete') {
      out.pending.push(application);
    }  else {
      out.evaluate.push(application);
    }
  }

  return {
    opening: resolve(data, 'opening', {}),
    totalApplicants: out.pending.length + out.evaluate.length + out.hire.length + out.reject.length,
    values: [
      {
        label: 'Pending Surveys',
        section: 'survey',
        values: out.pending
      },
      {
        label: 'Evaluate',
        section: 'evaluate',
        values: out.evaluate
      },
      {
        label: 'Hired',
        section: 'hire',
        values: out.hire
      },
      {
        label: 'Rejected',
        section: 'reject',
        values: out.reject
      }
    ]
  };
};

HiringDashboard.query = (token, { match }) => (
  HiringQuery(`
    {
      opening (id: ${match.params.id}) {
        id,
        name,
        closed,
        settings {
          invitation_token
        },
        applications(limit: 1000) {
          pagination {
            total
          }
          results {
            id,
            phone_number,
            resume_url,
            status,
            user {
              first_name,
              last_name,
              email
            }
            assessment {
              progress,
              scored,
              validity_errors,
              validity_score
            }
          }
        },
        settings {
          invitation_token
        },
        target_groupings {
          results {
            finalized,
            id,
            name
          }
        }
      }
    }
  `)
);

export default withRouter(withData(HiringDashboard));
